module.exports = __webpack_public_path__ + "img/Material_Desing.08bbd869.svg";